import { CSSProperties, ChangeEvent, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { CustomInput } from '../../shared/uiComponents';
import { FilterIcon, SearchIcon } from '../../shared/Assets/svg';

const SearchBar = ({
	label,
	hasFilter = false,
	style = { marginTop: '28px' },
}: {
	hasFilter?: boolean;
	label?: string;
	style?: CSSProperties;
}) => {
	const [params, setParams] = useSearchParams();
	const [startSearch, setStartSearch] = useState<string | null>('');

	const onSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
		const value = event.target.value;

		setStartSearch(value);
	};

	const toggleFilterHandler = () => {
		const filterParams = params.get('filter') === 'open' ? 'close' : 'open';
		params.set('filter', filterParams);
		setParams(params, { replace: true });
	};

	useEffect(() => {
		if (typeof startSearch !== 'string') return;
		const timeout = setTimeout(() => {
			const previousSearchValue = params.get('search');
			if (previousSearchValue === startSearch) return;
			params.set('search', startSearch);
			params.set('page', '1');
			setParams(params, { replace: true });
		}, 2000);

		// TODO - return void as in return () => void clearTimeout(timeout);
		// eslint-disable-next-line
		return () => clearTimeout(timeout);
	}, [params, setParams, startSearch]);

	return (
		<CustomInput
			label={label}
			value={startSearch}
			onChange={onSearchChange}
			placeholder="Search..."
			style={style}
			startAdornment={<SearchIcon title="Search" size={25} />}
			endAdornment={hasFilter && <FilterIcon title="Filter" size={20} onClick={toggleFilterHandler} />}
		/>
	);
};

export default SearchBar;
